import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { AuthUser } from '@monitoring-panel/types';

export interface Session {
  token: string;
  user?: AuthUser;
  expiresAt?: string;
}

// getOnInit reads localStorage synchronously at atom creation so the first
// render already sees the stored session. Without it the atom starts as null
// and ProtectedRoute redirects to the auth service before hydration.
export const sessionAtom = atomWithStorage<Session | null>(
  'authSession',
  null,
  undefined,
  { getOnInit: true },
);

export const isAuthenticatedAtom = atom((get) => get(sessionAtom) !== null);

export const userAtom = atom((get) => get(sessionAtom)?.user ?? null);

export const tokenAtom = atom((get) => get(sessionAtom)?.token ?? null);
